import { inject, Injectable } from "@angular/core";
import { MCAuthoritiesEventsEconomyUtils, MCCustomFunctionsParams, MCFormStateService } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsEconomyUtils extends MCAuthoritiesEventsEconomyUtils {

    private mcFormStateService = inject(MCFormStateService);

    override updateRashutP(customFunctionsParams: MCCustomFunctionsParams, sectionName: string, fieldName: string): void {
        const formState = this.mcFormStateService.getFormState();
        const entity = formState?.entity;
        this.updateRashutPByEntity(customFunctionsParams, sectionName, fieldName, entity);
    }

}
